import React from "react";
import TextField from "@material-ui/core/TextField";

export default props => (
    <div style={{ width: "100%", margin: "10px auto 10px auto" }}>
        <TextField
            id={props.id}
            label={props.text}
            type="text"
            value={props.prop}
            style={{ margin: "10px auto 10px auto", width: "100%" }}
            disabled
        />
    </div>
);
